import React from "react";
import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import SupportPage from "./components/SupportPage";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4caf50",
      contrastText: "#fff",
    },
  },
});

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <SupportPage />
      </ThemeProvider>
    </>
  );
}

export default App;
